import type { IconProps } from '.';

/**
 * Arrow Left Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ArrowLeftIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.91414 11.5L13.0606 7.35353L12.3535 6.64642L6.99992 12L12.3535 17.3535L13.0606 16.6464L8.91414 12.5H17.707V11.5H8.91414Z"
      fill="white"
    />
  </svg>
);

export default ArrowLeftIcon;
